module.exports = __webpack_public_path__ + "img/010020.99f86535.png";